module.exports = __webpack_public_path__ + "source/img/volume-on.5ac5661a.svg";